/** Layout strategy for title, subtitle, and suffix positioning */
export let SubtitleLayout = /*#__PURE__*/function (SubtitleLayout) {
  /** title and suffix in horizontal row, subtitle flows below entire row */
  SubtitleLayout["Inline"] = "inline";
  /** Default behavior: title and subtitle grouped vertically, then horizontally aligned with suffix */
  SubtitleLayout["Grouped"] = "grouped";
  return SubtitleLayout;
}({});

// Map behaviors by discriminant to make composing discriminated unions ergonomic

// Generic builder for item props that preserves the discriminated union
// ItemBase are props common to all items regardless of behavior

// ItemProps composes ItemBase with a data slice and the behavior by variant, keeping the union intact

// Composed interfaces

// Core

// Recompose from primitives to preserve the discriminated union rather than Omit from a composite

// Common card appearance props

// Collapsible-only behavior shape without requiring 'variant' in the public API
//# sourceMappingURL=types.js.map